<template>
    <div class="container">
        <div class="card">
            <h2 class="card-title text-center"> Vorversand </h2>
            <div class="card-body">
                <b-form-select v-model="selectedOperation" :options="operationOptions" class="mb-2"></b-form-select>
                <b-input-group class="mb-2" v-if="selectedOperation === 'preDelivery'">
                    <b-form-input id="deliveryTime" v-model="deliveryTimeInput" type="text" placeholder="H:m:s D-M-Y"></b-form-input>
                        <b-input-group-append>
                        <b-form-datepicker  v-model="deliveryTime" button-only right start-weekday="1" aria-controls="deliveryTime"></b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
                <b-form-textarea @paste="TextAreaNextLine" class="mb-2" v-model="customerorderIdsTextArea"></b-form-textarea>
                <div class="text-right mb-2">
                    <b-btn variant="secondary"  @click="sendData()">abesenden</b-btn>
                </div>
                <div v-if="results.length > 0" class="text-center">
                    <h4>Ergebnis</h4>
                    <b-table-simple>
                        <b-thead>
                            <b-tr>
                                <b-th>OrderId</b-th>
                                <b-th>Status</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="result in results" :key="result.id">
                                <b-td>
                                    {{result.id}}
                                </b-td>
                                <b-td>
                                    {{result.status}}
                                </b-td>                                
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            selectedOperation: null,
            deliveryTime : moment().format("DD-MM-YYYY HH:mm:ss"),
            operationOptions : [
                { value: null, text : "Vorversandart auswählen" , disabled: true},
                { value: "preDelivery", text : "Vorversand"},
                { value: "preDeliveryBan", text : "Vorversand verbieten"},
            ],
            customerorderIdsTextArea : "",
            results: [],
            deliveryTimeInput : moment().format("DD.MM.YYYY HH:mm:ss"),
        }
    },
    watch:{
        deliveryTime(newVal){
            this.deliveryTimeInput = moment(newVal, 'DD-MM-YYYY HH:mm:ss').format("DD.MM.YYYY HH:mm:ss")
        }
    },
    methods : {
        sendData(){
            if (!this.selectedOperation) return alert("Bitte Vorversandart auswählen");
            this.results = [];

            const request = {
                operation: this.selectedOperation,
                deliveryTime: moment(this.deliveryTimeInput, "DD.MM.YYYY HH:mm:ss").format('DD-MM-YYYY HH:mm:ss'),
                customerOrderIds: this.customerorderIdsTextArea
            }
            axios.post("predelivery", request)
            .then(res => {
                console.log(res);
                this.results = res.data;
            })
            .catch(err => {
                console.log(err);
            })
        },

        TextAreaNextLine(event){
            const textArea = event.target;
            let cursorPosition = textArea.selectionStart;
            let value = textArea.value;
            
            // Check if the cursor is at the end + textfield not empty + last symbol not newLine character
            if (cursorPosition === value.length && this.customerorderIdsTextArea != "" &&
                this.customerorderIdsTextArea.slice(-1) != '\n' ) {

                // Append a newline character and set the new textArea value
                textArea.value = `${value}\n`;
                this.customerorderIdsTextArea = textArea.value;

                // Update the cursor position to the end of the new line
                Vue.nextTick(() => {
                textArea.selectionStart = cursorPosition + 1;
                textArea.selectionEnd = cursorPosition + 1;
                });
            } else {
                this.customerorderIdsTextArea = value;
            }
        },
        formattedDeliveryTime(){
            if(this.deliveryTime === null) return;
            this.deliveryTimeInput = moment(this.deliveryTime, "Y-M-D H:m:s").format('H:m:s D-M-Y')
        }  
    },
}
</script>
